import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IProfileService } from '@intigral/domain/lib/application/services/ProfileService';
import { type UserInfo } from '@intigral/domain/lib/core/entities/UserInfo';
import { useQuery } from '@tanstack/react-query';
import _ from 'lodash';
import h from '../../helpers/common';
import user from '../../helpers/user';
import { transformRewind, transformVodItem } from '../../utils/watchlistTransformers';

export const useUserWatchList = (
    profileGuid: string | undefined,
    user: UserInfo,
    country: string,
    providers: any,
    lang: string,
    programType = '',
    enabled = true
) => {
    return useQuery({
        queryKey: ['profiles', 'user-watchlist', profileGuid, h.getLang()],
        enabled: !!profileGuid,
        queryFn: async () => {
            try {
                const profileService = container.resolve<IProfileService>(DI.SERVICES.IProfileService);
                const watchlist = await profileService.getWatchlist(
                    user.apiKey,
                    profileGuid,
                    user.authToken,
                    user.identityToken,
                    {
                        country: country,
                        programType: programType,
                        tierGuid: user?.tierConfig?.tierGuid,
                        device: 'PC',
                    }
                );
                const entries = watchlist.entries ?? [];
                const mappedEntries = entries.map((e) =>
                    e.category === 'VOD' ? transformVodItem(e, providers, lang) : transformRewind(e, providers, lang)
                );
                return mappedEntries;
            } catch (error) {
                return [];
            }
        },
        staleTime: 0,
    });
};
